/**
 * Owner: Masa Bayu
 * File: author-profile-sidebar.tsx
 * Date:Time: 2026-10-17 16:05
 * Description: Shared profile sidebar nav — one concept across all profile pages.
 */

import { PROFILE_NAV } from './author-profile-data';
import { IconChip } from './author-profile-parts';

export interface ProfileSidebarProps {
  readonly activeId: string;
  readonly onNavigate: (path: string) => void;
}

export function ProfileSidebar({ activeId, onNavigate }: ProfileSidebarProps) {
  return (
    <aside className="axp__side" aria-label="Profile sections">
      <nav className="axp__nav">
        {PROFILE_NAV.map((item) => (
          <button
            key={item.id}
            type="button"
            className="axp__nav-item"
            data-active={item.id === activeId}
            onClick={() => {
              onNavigate(item.path);
            }}
          >
            <IconChip icon={item.icon} tint={item.tint} ink={item.ink} size={16} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="axp__side-promo">
        <p className="axp__side-promo-title">Write. Share. Inspire.</p>
        <p className="axp__side-promo-sub">Turn your ideas into widely read eBooks.</p>
        <button
          type="button"
          className="axp__side-promo-cta"
          onClick={() => {
            onNavigate('/author');
          }}
        >
          Go to Author Studio →
        </button>
      </div>
      <p className="axp__side-brand">
        <strong>QX eBook</strong>
        <span>Stories for a brighter tomorrow.</span>
      </p>
    </aside>
  );
}
